<template>
    <div id="list-users-component" class="w-full h-full">
        <div class="flex items-end justify-between gap-2">
            <span v-if="isLoading"> Cargando...</span>
            <custom-simple-select
                v-else
                v-model="option"
                :label="label"
                mode="search"
                class="w-full"
                :options="selectOptions"
                :disabled="!enabled"
                @change="onInput"
            />

            <app-button
                v-if="enabled"
                icon
                circle
                color="brand-purple"
                @click="reloadItems(true)"
            >
                <reload-icon class="h-5 w-5 text-white" />
            </app-button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import ReloadIcon from "@/components/icons/ReloadIcon.vue";
import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "BrandSelector",
    components: { ReloadIcon, CustomSimpleSelect },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => ({
                id: "",
                email: ""
            }),
            type: Object,
            require: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        },
        fill: {
            default: () => false,
            type: Boolean,
            required: false
        },
        label: {
            default: () => "Usuario",
            type: String,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        option: "",
        options: [],
        isLoading: true
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"]),
        ...mapState("commons", ["selectedMerchant"]),
        selectOptions() {
            return this.options.map((item) => ({
                label: `${item.firstName} ${item.lastName}`,
                value: item.id
            }));
        }
    },
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
        if (this.fill) {
            this.reloadItems(true);
        }
    },
    methods: {
        ...mapActions("users", ["listUsersMerchant"]),
        async reloadItems(required = true) {
            this.isLoading = true;
            try {
                this.options = await this.listUsersMerchant({
                    required,
                    merchantId: this.selectedMerchant.merchantId,
                    merchantType: this.selectedMerchant.merchantType
                });
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        setInput(value) {
            const aux = this.options.find((item) => item.id === value.id);
            if (!aux) {
                this.options = [value];
            }
            this.option = value.id ?? "";
            this.isLoading = false;
        },
        onInput() {
            const aux = this.options.find((item) => this.option === item.id);
            if (aux && this.option) {
                this.$emit("change", aux);
            }
        }
    }
};
</script>
